<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/transaction/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Transaction
      List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    Upload Transactions
  </div>
  <div class="page-content shadow p-3 position-relative">
    <h4>New Transactions CSV Upload</h4>
    <p class="mb-2">
      'Direct' will process the transactions now. Queue' will process the
      transactions at a later time (suitable for large transaction files)
    </p>
    <div class="radio-btn-group">
      <div *ngFor="let data of processType">
        <input
          type="radio"
          id="radio{{ data.name }}"
          name="selector"
          class="selector-item_radio"
          (change)="onProcessTypeSelect(data)" />
        <label for="radio{{ data.name }}" class="custom-label">
          <span class="radio-btn-text">
            <p>{{ data.name }}</p>
          </span>
        </label>
      </div>
    </div>
    <div class="row my-3">
      <div class="col-md-12">
        <div class="floating-label">
          <input type="file" class="floating-input" />
          <label for="csv">CSV File</label>
        </div>
      </div>
      <div class="col-md-12">
        <button class="btn primary-btn w-100 mt-3">Upload File</button>
      </div>
    </div>
    <span class="text-danger"><b>Please Note</b></span>
    <p>
      The first row must have these field headings: agent trans_ref, trans_type,
      purpose, source_of_income, payment method, sender_name, sender_addr,
      sender_tel, sender_id_type, sender_id_details, sender_nationality,
      sender_dob, bene_name, bene_address, bene_address2, bene_address3,
      bene_city, bene_state, bene_postcode, bene_tel, bene_mobile, bene_id_type,
      bene_id_details, bene_ac, bene_ac_type, bene_bank, bene_branch,
      bene_branch code, bene_branch_address, bene_branch_tel, bene branch city
      bene branch state, benet card number, collection point,
      collection_point_code, collection_point_bank, collection_point_address,
      collection_point_city, collection_pin, originating country, destination
      country, source currency, source_amount, dest currency, dest amount, rate,
      commission, source tax, service level, amount deposited, date deposited,
      bank account id, bank branch deposited, sms notification, sms
      confirmation, sms benet confirmation, agent fee, agent comments,
      sms_sender_mobile, sms bene_mobile, bene! utility_bill_company,
      bene_utility_bill_company_code, bene_utility_bill_accountNo, bene_utility
      bill_invoice, bene utility bill bank, bene_utility_bill_bankCode, bene
      utility bil description, benet utility bill address, bene
      utility_bill_city, bene utility bill state, sender mobile, sender
      address3, bene mobile transfer number, benet mobile_transfer network, bene
      mobile_transfer_network_credit_type, sender_bene relation, bene bank id,
      sender_org_type, sender_company_name, sender company type, sender company
      reg no, sender business type, sender city, sender state, sender postcode
    </p>
    <p>The header row is optional.</p>
    <p class="text-primary">Download Template</p>
  </div>
</div>
